import axios from "./Axios";
import { success, error } from "./ResponseHandler";
import GLOBAL from "../global";

const directLineTokenEndPoint = process.env.REACT_APP_DIRECT_LINE_TOKEN_ENDPOINT;
const vaAzureApi = process.env.REACT_APP_VA_AZURE_API_FOR_ASK_EMMA;

class AskEMMAApiService {
    async getDirectLineToken(tokenEndPoint = null) {
        try {
            const endPoint = tokenEndPoint || directLineTokenEndPoint;
            const response = await axios.get(endPoint);

            return success({ data: response });
        } catch (e) {
            return error(e);
        }
    }

    async getConversationInfo() {
        try {
            const response = await axios.post(`${vaAzureApi}/copilot/GetConversation`, {
                TestId: "TEST-6555",
                Tenant: GLOBAL.TENANT,
                PatientId: (GLOBAL.USER_INFO && GLOBAL.USER_INFO['ContactId']) || ''
            })

            return success(response);
        } catch (e) {
            return error(e)
        }
    }

    async saveConversationInfo(conversationId, token) {
        try {
            const response = await axios.post(`${vaAzureApi}/copilot/StoreConversation`, {
                TestId: "",
                Tenant: GLOBAL.TENANT,
                ConversationId: conversationId,
                Token: token,
                PatientId: (GLOBAL.USER_INFO && GLOBAL.USER_INFO['ContactId']) || ''
            })

            return success(response);
        } catch (e) {
            return error(e)
        }
    }

    async fetchRiskTrigger(testId = '') {
        try {
            const response = await axios.post(`${vaAzureApi}/copilot/RiskTriggerName`, {
                TestId: testId,
                Tenant: GLOBAL.TENANT,
                PatientId: (GLOBAL.USER_INFO && GLOBAL.USER_INFO['ContactId']) || ''
            });

            return success({ data: response} );
        } catch (e) {
            return error(e);
        }
    }
}

export default new AskEMMAApiService();
